/**************************************************************************************************************************************************
*   MODULE NAME     :  Search
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  10-02-2021
*   DESCRIPTION     :  Component to load Search page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2517014
*   DESCRIPTION: <GLSD>: Layer7 API Deprecation
*   removed unused/commented code
*   DATE: 28-Feb-2025
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2671327
*   DESCRIPTION: <GLSD>: Fix Dependabot Vulnerabilities
*   Fixed toggle of Search accordion
*   DATE: 02-Dec-2025
/**************************************************************************************************************************************************/
import React, { useContext } from "react";
import { Container, Row, Col, Form, Tabs, Tab, Button, OverlayTrigger, Tooltip, Card } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { FaSpinner, FaTrashAlt, FaChevronDown } from "react-icons/fa";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Select from "react-select";
import swal from "sweetalert";
import * as messages from "../common/MessagesPool"
import DataTableSelectRow from '../common/dataTable/DataTableSelectRow';
import { } from '../common/MessagesPool';
import { FromToDatePicker } from "../common/datePicker/MyDatePicker"
import "./Search.css";
import SearchResults from "./SearchResults";
import {
    loadAllProduct,
    loadAllCountry,
    loadAllExplanation,
    loadAllStatus
} from "../../actions/abstractActions";
import { loadUsersData } from "../../actions/userActions";
import {
    loadAllSavedSearch,
    getSearchCriteria,
    inactiveSaveSearch,
    saveSearch

} from "../../actions/searchActions";
import SaveSearchTitle from "./SaveSearchTitle";
import { ddmmmyyyyFormat } from "../common/DateFormat";
import SavedSearchResults from "./SavedSearchResults";
import DataTable from "../common/dataTable/DataTable";

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: "0",
            isLoading: false,
            disableSearch: false,
            showResults: false,
            showSaveSearchTitle: false,
            defaultTab: "advancedSearch",
            saveTitle: "",
            loadResults: false,
            loadSavedResults: true,
            searchCriteriaObject: {},
            selected: [],
            title: null,
            originalTitle: null,
            authors: null,
            documentSiteOrigin: null,
            siteProcessingDocument: null,
            status: null,
            otherStatus: null,
            product: null,
            country: null,
            includeDeleted: false,
            includeLegacyRecords: true,
            loggedUserDetails: this.props.loggedUserDetail,
            userRole: this.props.loggedUserDetail.role.includes("Business_Administrator"),
            deleteAllowed: this.props.loggedUserDetail.role.includes("Business_Administrator") || this.props.loggedUserDetail.role.includes("IT_Administrator"),
            received: null,
            language: null,
            institution: null,
            abstract: null,
            notes: null,
            explanation: null,
            absRecordScreener: null,
            fullTextScreener: null,
            recordCloser: null,
            lockedAt: {
                from: null,
                to: null
            },
            source: null,
            caseID: null,
            dateRecordReceived: {
                from: null,
                to: null
            },
            dateArticleOrdered: {
                from: null,
                to: null
            },
            dateArticleOrdered2: {
                from: null,
                to: null
            },
            dateArticleReceived: {
                from: null,
                to: null
            },
            dateAbstractReviewed: {
                from: null,
                to: null
            },
            dateArticleReviewed: {
                from: null,
                to: null
            },
            dateTranslationRequested: {
                from: null,
                to: null
            },
            dateTranslationReceived: {
                from: null,
                to: null
            },
            dateAbstractValid: {
                from: null,
                to: null
            },
            dateArticleValid: {
                from: null,
                to: null
            },
            dateTranslationValid: {
                from: null,
                to: null
            },
            dateClosed: {
                from: null,
                to: null
            },
            dateFlwUpReceived: {
                from: null,
                to: null
            },
            savedSearchDataList: [],
            sList: false,
            masterData: {
                productList: this.props.productData,
                statusList: this.props.statusData,
                explanationList: this.props.explanationData,
                countryList: this.props.countryData,
                siteList: [{ label: "Global", value: "Global" }, { label: "Japan", value: "Japan" }],
                userList: this.props.usersData,

            }
        };
        this.handleSubmitFunction = this.handleSubmitFunction.bind(this);
        this.handleSavedSearchFunction = this.handleSavedSearchFunction.bind(this);
        this.handleSelectTab = this.handleSelectTab.bind(this);
        this.handleResetFunction = this.handleResetFunction.bind(this);
        this.disableModal = this.disableModal.bind(this)
        this.saveSearchTitle = this.saveSearchTitle.bind(this);
        this.deleteSavedSearchModalFunction = this.deleteSavedSearchModalFunction.bind(this);
        this.saveSearchSelect = this.saveSearchSelect.bind(this);
        this._saveSearchSelect = this._saveSearchSelect.bind(this);
    }
    /**
     * Function to hide/show loader.
     * @param isLoading whether to hide or show loader
     */
    setLoader = isLoading => this.setState({ isLoading });
    /**
     * Function to initiate life cycle hooks.
     */
    componentDidMount() {
        this.loadMasterDataMount();

    }

    async loadMasterDataMount() {
        this.setLoader(true)
        await this.loadAllProduct();
        await this.loadAllCountry();
        await this.loadAllExplanation();
        await this.loadAllStatus();
        await this.getAllUsers();
        this.setLoader(false)

    }
    getAllUsers = async () => {
        let arr = this.state.masterData.userList;
        if (!(this.state.masterData.userList && this.state.masterData.userList.length > 0)) {
            let response = await this.props.loadUsersData();
            arr = response.data.result
        }
        let resultData = this.formatUserList(arr);
        this.setState(prevState => ({
            masterData: {
                ...this.state.masterData,
                userList: resultData
            }
        })
        );

    }
    loadAllProduct = async () => {
        let arr = this.state.masterData.productList;
        if (!(this.state.masterData.productList && this.state.masterData.productList.length > 0)) {
            let response = await this.props.loadAllProduct();
            arr = response.data.result
        }
        let resultData = this.formatMasterDataList(arr);
        this.setState(prevState => ({
            masterData: {
                ...this.state.masterData,
                productList: resultData
            }
        })
        );

    }

    loadAllCountry = async () => {
        let arr = this.state.masterData.countryList;
        if (!(this.state.masterData.countryList && this.state.masterData.countryList.length > 0)) {
            let response = await this.props.loadAllCountry();
            arr = response.data.result
        }
        let resultData = this.formatMasterDataList(arr);
        this.setState(prevState => ({
            masterData: {
                ...this.state.masterData,
                countryList: resultData
            }
        })
        );

    }

    loadAllExplanation = async () => {
        let arr = this.state.masterData.explanationList;
        if (!(this.state.masterData.explanationList && this.state.masterData.explanationList.length > 0)) {
            let response = await this.props.loadAllExplanation();
            arr = response.data.result
        }
        let resultData = this.formatMasterDataList(arr);
        this.setState(prevState => ({
            masterData: {
                ...this.state.masterData,
                explanationList: resultData
            }
        })
        );

    }

    loadAllStatus = async () => {
        let arr = this.state.masterData.statusList;
        if (!(this.state.masterData.statusList && this.state.masterData.statusList.length > 0)) {
            let response = await this.props.loadAllStatus();
            arr = response.data.result
        }
        let resultData = this.formatMasterDataList(arr);
        this.setState(prevState => ({
            masterData: {
                ...this.state.masterData,
                statusList: resultData
            }
        })
        );

    }
    loadSavedSearch = async () => {
        this.setLoader(true)
        let response = await this.props.loadAllSavedSearch();
        if (response && response.data && response.data.result) {
            let resultData = this.formatSavedSearchList(response.data.result);
            this.setState(prevState => ({
                savedSearchDataList: [...resultData],
                sList: true,
            })
            );
        }
        this.setLoader(false)
    }
    formatSavedSearchList = (dataArr = []) => {
        let result = dataArr.map(obj => {
            return {
                id: obj.userSavedSearchId,
                title: obj.title,
                date: obj.createdAt
            }
        });
        return result;
    }
    formatMasterDataList = (dataArr = []) => {
        let result = dataArr.map(obj => {
            return {
                label: obj.masterDataValue,
                value: obj.masterDataId
            }
        });
        result.sort((a, b) => a.label.localeCompare(b.label))

        return result;
    }
    formatUserList = (dataArr = []) => {
        let result = dataArr.map(obj => {
            return {
                label: obj.firstName + " " + obj.lastName,
                value: obj.systemId
            }
        });
        result.sort((a, b) => a.label.localeCompare(b.label))

        return result;
    }
    enableModal() {
        this.handleSubmitFunction(false)

        this.setState({
            showSaveSearchTitle: true
        })
    }
    disableModal() {
        this.setState({
            showSaveSearchTitle: false
        })
    }
    async saveSearchTitle(value) {
        this.setLoader(true)
        try {
            await this.props.saveSearch({
                title: value,
                active: true,
                createdBy: this.props.loggedUserDetail.userClientId
            },
                this.state.searchCriteriaObject)
            this.disableModal();
            await this.loadSavedSearch();
            this.setState({
                defaultTab: "savedSearch"
            })
            this.handleResetFunction()
        }
        catch (error) {
            console.log(error)
        }
        this.setLoader(false)
    }


    handleResetFunction = () => {
        this.setState({
            isLoading: false,
            loadResults: false,
            searchCriteriaObject: {},
            disableSearch: false,
            selected: [],
            title: "",
            authors: "",
            originalTitle: "",
            siteofOrigin: null,
            siteofProcessing: null,
            status: null,
            otherStatus: "",
            product: null,
            country: null,
            includeDeleted: false,
            includeLegacyRecords: true,
            received: "",
            language: "",
            institution: "",
            abstract: "",
            notes: "",
            explanation: "",
            absRecordScreener: null,
            fullTextScreener: null,
            recordCloser: null,
            lockedAt: {
                from: "",
                to: ""
            },
            source: "",
            caseID: "",
            dateRecordReceived: {
                from: "",
                to: ""
            },
            dateArticleOrdered: {
                from: "",
                to: ""
            },
            dateArticleOrdered2: {
                from: "",
                to: ""
            },
            dateArticleReceived: {
                from: "",
                to: ""
            },
            dateAbstractReviewed: {
                from: "",
                to: ""
            },
            dateArticleReviewed: {
                from: "",
                to: ""
            },
            dateTranslationRequested: {
                from: "",
                to: ""
            },
            dateTranslationReceived: {
                from: "",
                to: ""
            },
            dateAbstractValid: {
                from: "",
                to: ""
            },
            dateArticleValid: {
                from: "",
                to: ""
            },
            dateTranslationValid: {
                from: "",
                to: ""
            },
            dateClosed: {
                from: "",
                to: ""
            },
            dateFlwUpReceived: {
                from: "",
                to: ""
            }
        }, () => {
            console.log(this.state)
        });
    }
    checkFromToDates() {
        let obj = { ...this.state };
        let checkDate = false;
        Object.keys(obj).forEach(key => {
            if (key.toLowerCase().includes("date") || key.toLowerCase().includes("lock")) {

                if (!(obj[key]["from"] === null || obj[key]["to"] === null || obj[key]["from"] === "" || obj[key]["to"] === "") && new Date(obj[key]["from"]) > new Date(obj[key]["to"])) {
                    checkDate = checkDate || true
                }
            }
        })
        this.setState({
            disableSearch: checkDate
        })
    }
    handleSubmitFunction(val) {
        let obj = { ...this.state };
        Object.keys(obj).forEach(key => {
            if (obj[key] === null || obj[key].toString().trim() === "") {
                delete obj[key];
            }
            else if (obj[key].hasOwnProperty("from") && ((obj[key]["from"] === null || obj[key]["from"] === "") && (obj[key]["to"] === null || obj[key]["to"] === ""))) {
                delete obj[key];
            }
        });
        obj['countryId'] = obj.country ? obj.country.value : undefined;
        obj['statusId'] = obj.status ? obj.status.map((e) => e.value) : undefined;
        obj['productId'] = obj.product ? obj.product.value : undefined;
        obj['explanationId'] = obj.explanation ? obj.explanation.value : undefined;
        obj['siteProcessingDocument'] = obj.siteofProcessing ? obj.siteofProcessing.value : undefined;
        obj['documentSiteOrigin'] = obj.siteofOrigin ? obj.siteofOrigin.value : undefined;
        obj['caseManagerId1'] = obj.absRecordScreener ? obj.absRecordScreener.value : undefined;
        obj['caseManagerId2'] = obj.fullTextScreener ? obj.fullTextScreener.value : undefined;
        obj['caseManagerId3'] = obj.recordCloser ? obj.recordCloser.value : undefined;

        this.setState({
            showResults: false,
            loadResults: val,
            searchCriteriaObject: {
                title: obj.title,
                originalTitle: obj.originalTitle,
                authors: obj.authors,
                source: obj.source,
                abstract: obj.abstract,
                caseIds: obj.caseID,
                abstractLanguage: obj.language,
                institution: obj.institution,
                receivedFrom: obj.received,
                notes: obj.notes,
                otherStatus: obj.otherStatus,
                productId: obj.productId,
                countryId: obj.countryId,
                statusId: obj.statusId,
                explanationId: obj.explanationId,
                siteProcessingDocument: obj.siteProcessingDocument,
                documentSiteOrigin: obj.documentSiteOrigin,
                includeDeleted: obj.includeDeleted === true ? 1 : 0,
                includeLegacyRecords: obj.includeLegacyRecords === true ? 1 : 0,
                date_record_received: obj.dateRecordReceived,
                date_abstract_reviewed: obj.dateAbstractReviewed,
                date_article_ordered: obj.dateArticleOrdered,
                date_article_ordered2: obj.dateArticleOrdered2,
                date_closed: obj.dateClosed,
                date_abstract_valid: obj.dateAbstractValid,
                date_flw_up_received: obj.dateFlwUpReceived,
                date_article_valid: obj.dateArticleValid,
                date_translation_requested: obj.dateTranslationRequested,
                date_translation_received: obj.dateTranslationReceived,
                date_translation_valid: obj.dateTranslationValid,
                date_article_reviewed: obj.dateArticleReviewed,
                date_article_received: obj.dateArticleReceived,
                lock_by_date: obj.lockedAt,
                caseManagerId1: obj.caseManagerId1,
                caseManagerId2: obj.caseManagerId2,
                caseManagerId3: obj.caseManagerId3,
            },
            activeKey: "1"
        }, () =>
            console.log(this.state.searchCriteriaObject)
        )
    }
    handleSavedSearchFunction() {
        this.enableModal()

    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });

    }
    handleCheckBoxChange = (e, name, value) => {
        this.setState({
            [name]: !value
        });
    }

    onHandleSelectChange = (selectedOption, name) => {
        this.setState({
            [name]: selectedOption
        });
    }
    handleDateChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    handleDateChangeFromTo = (e, dateField) => {
        e.persist();
        this.setState(prevState => ({
            [e.target.name]: {
                ...this.state[e.target.name],
                [dateField]: e.target.value
            }
        })
        )
    }
    _handleDateChangeFromTo = (date, name, dateField) => {
        this.setState(prevState => ({
            [name]: {
                ...this.state[name],
                [dateField]: date
            }
        }), () => this.checkFromToDates()
        )
    }
    handleOnSelect = (row, isSelect) => {
        if (isSelect) {
            this.setState(() => ({
                selected: [...this.state.selected, row.id]
            }));
        } else {
            this.setState(() => ({
                selected: this.state.selected.filter(x => x !== row.id)
            }));
        }

    }

    handleOnSelectAll = (isSelect, rows) => {
        const ids = rows.map(r => r.id);
        if (isSelect) {
            this.setState(() => ({
                selected: ids
            }));
        } else {
            this.setState(() => ({
                selected: []
            }));
        }
    }
    deleteSavedSearchModalFunction() {
        swal({
            title: "Are you sure?",
            text: messages.DELETE_SAVED_SEARCH,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    this._deleteSavedSearchModalFunction();

                } else {
                }
            });
    }
    async _deleteSavedSearchModalFunction() {
        this.setLoader(true)
        await this.props.inactiveSaveSearch(this.state.selected);
        swal(messages.SAVED_SEARCH_DELETE_SUCCESS, {
            icon: "success",
        });
        this.setState({
            showResults: false,
        })
        await this.loadSavedSearch()
        this.setLoader(false)
    }
    async saveSearchSelect(id, _title, e) {
        e.stopPropagation();
        this._saveSearchSelect(id, _title);
    }

    async _saveSearchSelect(id, _title) {
        this.setLoader(true)
        this.setState({

            showResults: false,
        })
        try {
            let criteria = await this.props.getSearchCriteria(id);
            criteria = criteria.data.result;
            let obj = {}
            criteria.map((e) => {
                let val = e.value;
                if (e.fieldName.includes("date") || e.fieldName.includes("status") || e.fieldName.includes("lock"))
                    val = JSON.parse(val)
                else if (e.fieldName.includes("include"))
                    val = parseInt(e.value)
                obj[e.fieldName] = val
            })
            this.setState({
                saveTitle: _title,
                loadSavedResults: true,
                showResults: true,
                sList: false,

            })
            this.setState({
                sList: true,
                searchCriteriaObject: { ...obj },
            })
        } catch (error) {
            console.log(error)
        }
        this.setLoader(false)

    }

    handleSelectTab(key) {
        this.setState({
            defaultTab: key,
            loadResults: false,
            loadSavedResults: false
        }
        );
        this.handleResetFunction();
        if (key === "savedSearch") {
            this.handleResetFunction();

            this.loadSavedSearch();
        }

    }
    ContextAwareToggleResults = ({ children, eventKey, callback }) => {
        const decoratedOnClick = useAccordionToggle(
            eventKey,
            () => callback && callback(eventKey),
        );
        return (
            <span onClick={decoratedOnClick}>
                {children}
            </span>
        );
    }

    //** Accordion Button Collapse -and expand */
    ContextAwareToggle = ({ children, eventKey, callback }) => {
        const currentEventKey = useContext(AccordionContext);
        const decoratedOnClick = useAccordionToggle(
            eventKey,
            () => callback && callback(eventKey),
        );
        const isCurrentEventKey = currentEventKey === eventKey;
        return (
            <button
                type="button"
                className="float-right"
                style={
                    {
                        backgroundColor: "transparent",
                        border: "none",
                        color: 'white',
                        transform: !isCurrentEventKey ? 'rotate(0deg)' : 'rotate(180deg)',
                    }}
                onClick={decoratedOnClick}
            >
                {children}
            </button>
        );
    }

    render() {
        const { saveTitle, isLoading, disableSearch, userRole, defaultTab, loadSavedResults, loadResults, showSaveSearchTitle, showResults, title, originalTitle, siteofOrigin, siteofProcessing, dateRecordReceivedStart, dateRecordReceivedEnd,
            authors, status, otherStatus, product, country, received, language, institution, abstract, notes, explanation, absRecordScreener, lockedAt,
            fullTextScreener, recordCloser, source, caseID, dateRecordReceived, dateArticleOrdered,
            dateArticleOrdered2, dateArticleReceived, dateFlwUpReceived, dateClosed,
            dateTranslationValid, dateArticleValid, dateAbstractValid, dateTranslationReceived, dateTranslationRequested, includeDeleted, includeLegacyRecords,
            dateArticleReviewed, dateAbstractReviewed, masterData, sList, savedSearchDataList, searchCriteriaObject, selected, deleteAllowed } = this.state;
        const { productList, countryList, statusList, explanationList, siteList, userList } = masterData;
        function filterType(cell, row) {
            // just return type for filtering or searching.
            return cell.type;
        }
        const savedSearchDataColumns = [
            {
                dataField: "userSavedSearchId",
                text: "userSavedSearchId",
                hidden: true,
            },
            {
                dataField: 'title',
                text: 'title',
                sort: true,
                hidden: true,
                formatter: (cellContent, row) => {
                    return row ? row.title : '';
                },

            },
            {
                dataField: 'title',
                text: 'Saved Search Description',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '70%' };
                },
                style: { textAlign: "left" },
                formatter: (cellContent, row) => {
                    return <span className="fake-link"
                        style={{ textAlign: "left" }}
                        onClick={(e) => this.saveSearchSelect(row.id, row.title, e)}
                    >{row.title}</span>
                },
                events: {
                    onClick: (e, column, columnIndex, row, rowIndex) => {
                        e.stopPropagation();
                    },
                },

            },
            {
                dataField: 'date',
                text: 'date',
                sort: true,
                formatter: (cellContent, row) => {
                    return row && row.date ? ddmmmyyyyFormat(row.date) : "";
                },
                events: {
                    onClick: (e, column, columnIndex, row, rowIndex) => {
                        e.stopPropagation();
                    },
                },
            }]

        return (
            <>
                <table className="print-table">
                    <thead>
                        <tr>
                            <td>
                                <div className="page-header-space"></div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div className="CommonWrap searchPagePrint">
                                    <Container fluid>
                                        <div className="headerpart">
                                            <h1>Search Abstracts</h1>
                                        </div>
                                        <div className="search-common">
                                            <Tabs id="addAbstractTab"
                                                onSelect={this.handleSelectTab}
                                                activeKey={defaultTab}
                                                defaultActiveKey="advancedSearch">
                                                <Tab eventKey="advancedSearch" title="Search">
                                                    <Accordion onSelect={(key)=>this.setState({activeKey: String(key)})} activeKey={this.state.activeKey}>
                                                        <div >
                                                            <Card>
                                                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                                                    Search Criteria
                                                                    <this.ContextAwareToggle eventKey="0">
                                                                        <FaChevronDown></FaChevronDown>
                                                                    </this.ContextAwareToggle>
                                                                </Accordion.Toggle>
                                                                <Accordion.Collapse eventKey="0">
                                                                    <Card.Body>
                                                                        <div className="advancedSearch">
                                                                            <Row>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="title">
                                                                                        <Form.Label>Title
                                                                                        </Form.Label>
                                                                                        <Form.Control type="text" name="title"
                                                                                            value={title} onChange={this.handleChange}
                                                                                            required />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="originalTitle">
                                                                                        <Form.Label>Original Title
                                                                                        </Form.Label>
                                                                                        <Form.Control type="text" name="originalTitle"
                                                                                            value={originalTitle} onChange={this.handleChange}
                                                                                            required />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="authors">
                                                                                        <Form.Label>Author
                                                                                        </Form.Label>
                                                                                        <Form.Control type="text" name="authors"
                                                                                            value={authors} onChange={this.handleChange}
                                                                                            required />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={3}>
                                                                                    <Form.Group controlId="source">
                                                                                        <Form.Label>Source
                                                                                        </Form.Label>
                                                                                        <Form.Control type="text" name="source"
                                                                                            value={source} onChange={this.handleChange}
                                                                                            required />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="received">
                                                                                        <Form.Label>Received From
                                                                                        </Form.Label>
                                                                                        <Form.Control type="text" name="received"
                                                                                            value={received} onChange={this.handleChange}
                                                                                            required />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="caseID">
                                                                                        <Form.Label>Case ID
                                                                                        </Form.Label>
                                                                                        <Form.Control as="textarea" rows="2" name="caseID"
                                                                                            value={caseID} onChange={this.handleChange}
                                                                                            required />
                                                                                    </Form.Group>
                                                                                </Col>

                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="language">
                                                                                        <Form.Label>Language
                                                                                        </Form.Label>
                                                                                        <Form.Control type="text" name="language"
                                                                                            value={language} onChange={this.handleChange}
                                                                                            required />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={3} >
                                                                                    <Form.Group controlId="institution">
                                                                                        <Form.Label>Institution
                                                                                        </Form.Label>
                                                                                        <Form.Control type="text" name="institution"
                                                                                            value={institution} onChange={this.handleChange}
                                                                                            required />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="country">
                                                                                        <Form.Label>Country
                                                                                        </Form.Label>
                                                                                        <Select
                                                                                            name="country"
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                            menuPortalTarget={document.body}
                                                                                            options={countryList}
                                                                                            value={country}
                                                                                            maxMenuHeight={130}
                                                                                            onChange={selectedOption =>
                                                                                                this.onHandleSelectChange(selectedOption, "country")}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="product">
                                                                                        <Form.Label>Product
                                                                                        </Form.Label>
                                                                                        <Select
                                                                                            name="product"
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                            menuPortalTarget={document.body}
                                                                                            options={productList}
                                                                                            value={product}
                                                                                            maxMenuHeight={130}
                                                                                            onChange={selectedOption =>
                                                                                                this.onHandleSelectChange(selectedOption, "product")}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>


                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="siteofProcessing">
                                                                                        <Form.Label>Site of Processing
                                                                                        </Form.Label>
                                                                                        <Select
                                                                                            name="siteofProcessing"
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                            menuPortalTarget={document.body}
                                                                                            options={siteList}
                                                                                            value={siteofProcessing}
                                                                                            maxMenuHeight={130}
                                                                                            onChange={selectedOption =>
                                                                                                this.onHandleSelectChange(selectedOption, "siteofProcessing")}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={3} >
                                                                                    <Form.Group controlId="siteofOrigin">
                                                                                        <Form.Label> Site of Origin
                                                                                        </Form.Label>
                                                                                        <Select
                                                                                            name="siteofOrigin"
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                            menuPortalTarget={document.body}
                                                                                            options={siteList}
                                                                                            value={siteofOrigin}
                                                                                            maxMenuHeight={130}
                                                                                            onChange={selectedOption =>
                                                                                                this.onHandleSelectChange(selectedOption, "siteofOrigin")}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>

                                                                            </Row>
                                                                            <Row>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="status">
                                                                                        <Form.Label> Status
                                                                                        </Form.Label>
                                                                                        <Select
                                                                                            isMulti
                                                                                            name="status"
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                            menuPortalTarget={document.body}
                                                                                            options={statusList}
                                                                                            value={status}
                                                                                            maxMenuHeight={130}
                                                                                            onChange={selectedOption =>
                                                                                                this.onHandleSelectChange(selectedOption, "status")}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="otherStatus">
                                                                                        <Form.Label>Other Status
                                                                                        </Form.Label>
                                                                                        <Form.Control type="text" name="otherStatus"
                                                                                            value={otherStatus} onChange={this.handleChange}
                                                                                            required />
                                                                                    </Form.Group>
                                                                                </Col>

                                                                                <Col sm="6" >
                                                                                    <Row>

                                                                                        <Col className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <Form.Label>Lock By Date (From)</Form.Label>

                                                                                                <FromToDatePicker name="lockedAt"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "lockedAt", "from")}
                                                                                                    selected={lockedAt.from === null ? "" : lockedAt.from}
                                                                                                    isInvalid={((new Date(lockedAt.from) > new Date("2999-12-31")) || (new Date(lockedAt.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={lockedAt.from} value={lockedAt.from}
                                                                                                    defaultvalue={lockedAt.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col >
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <Form.Label>Lock By Date(To)</Form.Label>

                                                                                                <FromToDatePicker name="lockedAt"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "lockedAt", "to")}
                                                                                                    selected={lockedAt.to === null ? "" : lockedAt.to}
                                                                                                    isInvalid={((new Date(lockedAt.to) > new Date("2999-12-31")) || (new Date(lockedAt.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={lockedAt.to} value={lockedAt.to}
                                                                                                    defaultvalue={lockedAt.to}

                                                                                                    required />
                                                                                                {lockedAt.from && lockedAt.to && (new Date(lockedAt.from) > new Date(lockedAt.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}

                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>

                                                                            </Row>
                                                                            <Row>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="explanation">
                                                                                        <Form.Label>Explanation
                                                                                        </Form.Label>
                                                                                        <Select
                                                                                            name="explanation"
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                            menuPortalTarget={document.body}
                                                                                            options={explanationList}
                                                                                            value={explanation}
                                                                                            maxMenuHeight={130}
                                                                                            onChange={selectedOption =>
                                                                                                this.onHandleSelectChange(selectedOption, "explanation")}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="abstract">
                                                                                        <Form.Label>Abstract
                                                                                        </Form.Label>
                                                                                        <Form.Control as="textarea" rows="2" name="abstract"
                                                                                            value={abstract} onChange={this.handleChange}
                                                                                            required />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="notes">
                                                                                        <Form.Label>Notes
                                                                                        </Form.Label>
                                                                                        <Form.Control as="textarea" rows="2" name="notes"
                                                                                            value={notes} onChange={this.handleChange}
                                                                                            required />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col className="mt-4 ml-4">
                                                                                    <Form.Group controlId="includeLegacyRecords">
                                                                                        <Form.Check type="checkbox" as="input" label="Include Legacy Records"
                                                                                            checked={includeLegacyRecords}
                                                                                            onChange={(e) => this.handleCheckBoxChange(e, "includeLegacyRecords", includeLegacyRecords)}
                                                                                        />
                                                                                    </Form.Group></Col>

                                                                            </Row>
                                                                            <Row>

                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="absRecordScreener">
                                                                                        <Form.Label>Abstract Record Screener
                                                                                        </Form.Label>
                                                                                        <Select
                                                                                            name="absRecordScreener"
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                            menuPortalTarget={document.body}
                                                                                            options={userList}
                                                                                            value={absRecordScreener}
                                                                                            maxMenuHeight={130}
                                                                                            onChange={selectedOption =>
                                                                                                this.onHandleSelectChange(selectedOption, "absRecordScreener")}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>


                                                                                <Col sm={3} className="pr-0" >
                                                                                    <Form.Group controlId="fullTextScreener">
                                                                                        <Form.Label>Full Text Screener
                                                                                        </Form.Label>
                                                                                        <Select
                                                                                            name="fullTextScreener"
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                            menuPortalTarget={document.body}
                                                                                            options={userList}
                                                                                            value={fullTextScreener}
                                                                                            maxMenuHeight={130}
                                                                                            onChange={selectedOption =>
                                                                                                this.onHandleSelectChange(selectedOption, "fullTextScreener")}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>

                                                                                <Col sm={3} className="pr-0">
                                                                                    <Form.Group controlId="recordCloser">
                                                                                        <Form.Label>Record Closer
                                                                                        </Form.Label>
                                                                                        <Select
                                                                                            name="recordCloser"
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                            menuPortalTarget={document.body}
                                                                                            options={userList}
                                                                                            value={recordCloser}
                                                                                            maxMenuHeight={130}
                                                                                            onChange={selectedOption =>
                                                                                                this.onHandleSelectChange(selectedOption, "recordCloser")}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                {deleteAllowed &&
                                                                                    <Col className="mt-4 ml-4">
                                                                                        <Form.Group controlId="includeDeleted">
                                                                                            <Form.Check type="checkbox" as="input" label="Include Deleted" id="includeDeleted" checked={includeDeleted}

                                                                                                onChange={(e) => this.handleCheckBoxChange(e, "includeDeleted", includeDeleted)}

                                                                                            />
                                                                                        </Form.Group></Col>}

                                                                            </Row>

                                                                            <Row>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0 mt-4">
                                                                                            Date Record Received:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <Form.Label>From</Form.Label>
                                                                                                <FromToDatePicker name="dateRecordReceived"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateRecordReceived", "from")}
                                                                                                    selected={dateRecordReceived.from === null ? "" : dateRecordReceived.from}
                                                                                                    isInvalid={((new Date(dateRecordReceived.from) > new Date("2999-12-31")) || (new Date(dateRecordReceived.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateRecordReceived.from} value={dateRecordReceived.from}
                                                                                                    defaultvalue={dateRecordReceived.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <Form.Label>To</Form.Label>
                                                                                                <FromToDatePicker name="dateRecordReceived"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateRecordReceived", "to")}
                                                                                                    selected={dateRecordReceived.to === null ? "" : dateRecordReceived.to}
                                                                                                    isInvalid={((new Date(dateRecordReceived.to) > new Date("2999-12-31")) || (new Date(dateRecordReceived.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateRecordReceived.to} value={dateRecordReceived.to}
                                                                                                    defaultvalue={dateRecordReceived.to}
                                                                                                    required />
                                                                                                {dateRecordReceived.from && dateRecordReceived.to && (new Date(dateRecordReceived.from) > new Date(dateRecordReceived.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}

                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0 mt-4">
                                                                                            Date Record Reviewed:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <Form.Label>From</Form.Label>

                                                                                                <FromToDatePicker name="dateAbstractReviewed"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateAbstractReviewed", "from")}
                                                                                                    selected={dateAbstractReviewed.from === null ? "" : dateAbstractReviewed.from}
                                                                                                    isInvalid={((new Date(dateAbstractReviewed.from) > new Date("2999-12-31")) || (new Date(dateAbstractReviewed.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateAbstractReviewed.from} value={dateAbstractReviewed.from}
                                                                                                    defaultvalue={dateAbstractReviewed.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <Form.Label>To</Form.Label>

                                                                                                <FromToDatePicker name="dateAbstractReviewed"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateAbstractReviewed", "to")}
                                                                                                    selected={dateAbstractReviewed.to === null ? "" : dateAbstractReviewed.to}
                                                                                                    isInvalid={((new Date(dateAbstractReviewed.to) > new Date("2999-12-31")) || (new Date(dateAbstractReviewed.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateAbstractReviewed.to} value={dateAbstractReviewed.to}
                                                                                                    defaultvalue={dateAbstractReviewed.to}
                                                                                                    required />
                                                                                                {dateAbstractReviewed.from && dateAbstractReviewed.to && (new Date(dateAbstractReviewed.from) > new Date(dateAbstractReviewed.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>

                                                                            </Row>
                                                                            <br></br>
                                                                            <Row>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0">
                                                                                            Date Article Ordered:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <FromToDatePicker name="dateArticleOrdered"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateArticleOrdered", "from")}
                                                                                                    selected={dateArticleOrdered.from === null ? "" : dateArticleOrdered.from}
                                                                                                    isInvalid={((new Date(dateArticleOrdered.from) > new Date("2999-12-31")) || (new Date(dateArticleOrdered.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateArticleOrdered.from} value={dateArticleOrdered.from}
                                                                                                    defaultvalue={dateArticleOrdered.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <FromToDatePicker name="dateArticleOrdered"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateArticleOrdered", "to")}
                                                                                                    selected={dateArticleOrdered.to === null ? "" : dateArticleOrdered.to}
                                                                                                    isInvalid={((new Date(dateArticleOrdered.to) > new Date("2999-12-31")) || (new Date(dateArticleOrdered.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateArticleOrdered.to} value={dateArticleOrdered.to}
                                                                                                    defaultvalue={dateArticleOrdered.to}
                                                                                                    required />
                                                                                                {dateArticleOrdered.from && dateArticleOrdered.to && (new Date(dateArticleOrdered.from) > new Date(dateArticleOrdered.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}

                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0">
                                                                                            Date Article Ordered2:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <FromToDatePicker
                                                                                                    name="dateArticleOrdered2"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateArticleOrdered2", "from")}
                                                                                                    selected={dateArticleOrdered2.from === null ? "" : dateArticleOrdered2.from}
                                                                                                    isInvalid={((new Date(dateArticleOrdered2.from) > new Date("2999-12-31")) || (new Date(dateArticleOrdered2.from) < new Date("1970-01-01")))}
                                                                                                    placeholder={dateArticleOrdered2.from} value={dateArticleOrdered2.from}
                                                                                                    defaultvalue={dateArticleOrdered2.from}
                                                                                                    required
                                                                                                />

                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <FromToDatePicker name="dateArticleOrdered2"
                                                                                                    isInvalid={((new Date(this.state.dateArticleOrdered2.to) > new Date("2999-12-31")) || (new Date(this.state.dateArticleOrdered2.to) < new Date("1970-01-01")))}
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateArticleOrdered2", "to")}
                                                                                                    selected={dateArticleOrdered2.to === null ? "" : dateArticleOrdered2.to}
                                                                                                    //isInvalid={((new Date(dateArticleOrdered2.to) > new Date("2999-12-31")) || (new Date(dateArticleOrdered2.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateArticleOrdered2.to} value={dateArticleOrdered2.to}
                                                                                                    defaultvalue={dateArticleOrdered2.to}
                                                                                                    onKeyDown={(e) => e.preventDefault()}
                                                                                                    min="1970-01-01"
                                                                                                    max="2999-12-31"
                                                                                                    required
                                                                                                />
                                                                                                {dateArticleOrdered2.from && dateArticleOrdered2.to && (new Date(dateArticleOrdered2.from) > new Date(dateArticleOrdered2.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0">
                                                                                            Date Translation Requested:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <FromToDatePicker name="dateTranslationRequested"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateTranslationRequested", "from")}
                                                                                                    selected={dateTranslationRequested.from === null ? "" : dateTranslationRequested.from}
                                                                                                    isInvalid={((new Date(dateTranslationRequested.from) > new Date("2999-12-31")) || (new Date(dateTranslationRequested.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateTranslationRequested.from} value={dateTranslationRequested.from}
                                                                                                    defaultvalue={dateTranslationRequested.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <FromToDatePicker name="dateTranslationRequested"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateTranslationRequested", "to")}
                                                                                                    selected={dateTranslationRequested.to === null ? "" : dateTranslationRequested.to}
                                                                                                    isInvalid={((new Date(dateTranslationRequested.to) > new Date("2999-12-31")) || (new Date(dateTranslationRequested.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateTranslationRequested.to} value={dateTranslationRequested.to}
                                                                                                    defaultvalue={dateTranslationRequested.to}
                                                                                                    required />
                                                                                                {dateTranslationRequested.from && dateTranslationRequested.to && (new Date(dateTranslationRequested.from) > new Date(dateTranslationRequested.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>

                                                                            </Row>
                                                                            <br></br>
                                                                            <Row>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0">
                                                                                            Date Article Received:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <FromToDatePicker name="dateArticleReceived"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateArticleReceived", "from")}
                                                                                                    selected={dateArticleReceived.from === null ? "" : dateArticleReceived.from}
                                                                                                    isInvalid={((new Date(dateArticleReceived.from) > new Date("2999-12-31")) || (new Date(dateArticleReceived.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateArticleReceived.from} value={dateArticleReceived.from}
                                                                                                    defaultvalue={dateArticleReceived.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0" >
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <FromToDatePicker name="dateArticleReceived"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateArticleReceived", "to")}
                                                                                                    selected={dateArticleReceived.to === null ? "" : dateArticleReceived.to}
                                                                                                    isInvalid={((new Date(dateArticleReceived.to) > new Date("2999-12-31")) || (new Date(dateArticleReceived.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateArticleReceived.to} value={dateArticleReceived.to}
                                                                                                    defaultvalue={dateArticleReceived.to}
                                                                                                    required />
                                                                                                {dateArticleReceived.from && dateArticleReceived.to && (new Date(dateArticleReceived.from) > new Date(dateArticleReceived.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>

                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0">
                                                                                            Date Article Reviewed:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <FromToDatePicker name="dateArticleReviewed"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateArticleReviewed", "from")}
                                                                                                    selected={dateArticleReviewed.from === null ? "" : dateArticleReviewed.from}
                                                                                                    isInvalid={((new Date(dateArticleReviewed.from) > new Date("2999-12-31")) || (new Date(dateArticleReviewed.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateArticleReviewed.from} value={dateArticleReviewed.from}
                                                                                                    defaultvalue={dateArticleReviewed.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0" >
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <FromToDatePicker name="dateArticleReviewed"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateArticleReviewed", "to")}
                                                                                                    selected={dateArticleReviewed.to === null ? "" : dateArticleReviewed.to}
                                                                                                    isInvalid={((new Date(dateArticleReviewed.to) > new Date("2999-12-31")) || (new Date(dateArticleReviewed.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateArticleReviewed.to} value={dateArticleReviewed.to}
                                                                                                    defaultvalue={dateArticleReviewed.to}
                                                                                                    required />
                                                                                                {dateArticleReviewed.from && dateArticleReviewed.to && (new Date(dateArticleReviewed.from) > new Date(dateArticleReviewed.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>
                                                                            </Row>

                                                                            <Row>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0">
                                                                                            Date Translation Received:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <FromToDatePicker name="dateTranslationReceived"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateTranslationReceived", "from")}
                                                                                                    selected={dateTranslationReceived.from === null ? "" : dateTranslationReceived.from}
                                                                                                    isInvalid={((new Date(dateTranslationReceived.from) > new Date("2999-12-31")) || (new Date(dateTranslationReceived.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateTranslationReceived.from} value={dateTranslationReceived.from}
                                                                                                    defaultvalue={dateTranslationReceived.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0" >
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <FromToDatePicker name="dateTranslationReceived"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateTranslationReceived", "to")}
                                                                                                    selected={dateTranslationReceived.to === null ? "" : dateTranslationReceived.to}
                                                                                                    isInvalid={((new Date(dateTranslationReceived.to) > new Date("2999-12-31")) || (new Date(dateTranslationReceived.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateTranslationReceived.to} value={dateTranslationReceived.to}
                                                                                                    defaultvalue={dateTranslationReceived.to}
                                                                                                    required />
                                                                                                {dateTranslationReceived.from && dateTranslationReceived.to && (new Date(dateTranslationReceived.from) > new Date(dateTranslationReceived.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0">
                                                                                            Date Follow-up Received:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <FromToDatePicker name="dateFlwUpReceived"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateFlwUpReceived", "from")}
                                                                                                    selected={dateFlwUpReceived.from === null ? "" : dateFlwUpReceived.from}
                                                                                                    isInvalid={((new Date(dateFlwUpReceived.from) > new Date("2999-12-31")) || (new Date(dateFlwUpReceived.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateFlwUpReceived.from} value={dateFlwUpReceived.from}
                                                                                                    defaultvalue={dateFlwUpReceived.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <FromToDatePicker name="dateFlwUpReceived"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateFlwUpReceived", "to")}
                                                                                                    selected={dateFlwUpReceived.to === null ? "" : dateFlwUpReceived.to}
                                                                                                    isInvalid={((new Date(dateFlwUpReceived.to) > new Date("2999-12-31")) || (new Date(dateFlwUpReceived.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateFlwUpReceived.to} value={dateFlwUpReceived.to}
                                                                                                    defaultvalue={dateFlwUpReceived.to}
                                                                                                    required />
                                                                                                {dateFlwUpReceived.from && dateFlwUpReceived.to && (new Date(dateFlwUpReceived.from) > new Date(dateFlwUpReceived.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}

                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>

                                                                            </Row>
                                                                            <br></br>
                                                                            <Row>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0">
                                                                                            Date Abstract Valid:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <FromToDatePicker name="dateAbstractValid"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateAbstractValid", "from")}
                                                                                                    selected={dateAbstractValid.from === null ? "" : dateAbstractValid.from}
                                                                                                    isInvalid={((new Date(dateAbstractValid.from) > new Date("2999-12-31")) || (new Date(dateAbstractValid.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateAbstractValid.from} value={dateAbstractValid.from}
                                                                                                    defaultvalue={dateAbstractValid.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <FromToDatePicker name="dateAbstractValid"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateAbstractValid", "to")}
                                                                                                    selected={dateAbstractValid.to === null ? "" : dateAbstractValid.to}
                                                                                                    isInvalid={((new Date(dateAbstractValid.to) > new Date("2999-12-31")) || (new Date(dateAbstractValid.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateAbstractValid.to} value={dateAbstractValid.to}
                                                                                                    defaultvalue={dateAbstractValid.to}
                                                                                                    required />
                                                                                                {dateAbstractValid.from && dateAbstractValid.to && (new Date(dateAbstractValid.from) > new Date(dateAbstractValid.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}

                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0">
                                                                                            Date Article Valid:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <FromToDatePicker name="dateArticleValid"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateArticleValid", "from")}
                                                                                                    selected={dateArticleValid.from === null ? "" : dateArticleValid.from}
                                                                                                    isInvalid={((new Date(dateArticleValid.from) > new Date("2999-12-31")) || (new Date(dateArticleValid.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateArticleValid.from} value={dateArticleValid.from}
                                                                                                    defaultvalue={dateArticleValid.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0" >
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <FromToDatePicker name="dateArticleValid"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateArticleValid", "to")}
                                                                                                    selected={dateArticleValid.to === null ? "" : dateArticleValid.to}
                                                                                                    isInvalid={((new Date(dateArticleValid.to) > new Date("2999-12-31")) || (new Date(dateArticleValid.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateArticleValid.to} value={dateArticleValid.to}
                                                                                                    defaultvalue={dateArticleValid.to}
                                                                                                    required />
                                                                                                {dateArticleValid.from && dateArticleValid.to && (new Date(dateArticleValid.from) > new Date(dateArticleValid.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}

                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0">
                                                                                            Date Translation Valid:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <FromToDatePicker name="dateTranslationValid"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateTranslationValid", "from")}
                                                                                                    selected={dateTranslationValid.from === null ? "" : dateTranslationValid.from}
                                                                                                    isInvalid={((new Date(dateTranslationValid.from) > new Date("2999-12-31")) || (new Date(dateTranslationValid.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateTranslationValid.from} value={dateTranslationValid.from}
                                                                                                    defaultvalue={dateTranslationValid.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <FromToDatePicker name="dateTranslationValid"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateTranslationValid", "to")}
                                                                                                    selected={dateTranslationValid.to === null ? "" : dateTranslationValid.to}
                                                                                                    isInvalid={((new Date(dateTranslationValid.to) > new Date("2999-12-31")) || (new Date(dateTranslationValid.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateTranslationValid.to} value={dateTranslationValid.to}
                                                                                                    defaultvalue={dateTranslationValid.to}
                                                                                                    required />
                                                                                                {dateTranslationValid.from && dateTranslationValid.to && (new Date(dateTranslationValid.from) > new Date(dateTranslationValid.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}

                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>
                                                                                <Col sm="6" >
                                                                                    <Row>
                                                                                        <Col sm="4" className="formtextLabel pr-0">
                                                                                            Date Closed:
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrFrom">
                                                                                                <FromToDatePicker name="dateClosed"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateClosed", "from")}
                                                                                                    selected={dateClosed.from === null ? "" : dateClosed.from}
                                                                                                    isInvalid={((new Date(dateClosed.from) > new Date("2999-12-31")) || (new Date(dateClosed.from) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateClosed.from} value={dateClosed.from}
                                                                                                    defaultvalue={dateClosed.from}
                                                                                                    required />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={4} className="pr-0">
                                                                                            <Form.Group controlId="drrTo">
                                                                                                <FromToDatePicker name="dateClosed"
                                                                                                    onChange={(date) => this._handleDateChangeFromTo(date, "dateClosed", "to")}
                                                                                                    selected={dateClosed.to === null ? "" : dateClosed.to}
                                                                                                    isInvalid={((new Date(dateClosed.to) > new Date("2999-12-31")) || (new Date(dateClosed.to) < new Date("1970-01-01")))}

                                                                                                    placeholder={dateClosed.to} value={dateClosed.to}
                                                                                                    defaultvalue={dateClosed.to}
                                                                                                    required />
                                                                                                {dateClosed.from && dateClosed.to && (new Date(dateClosed.from) > new Date(dateClosed.to)) && <Form.Control.Feedback type="invalid" className="d-block">To Date should not be less than From Date</Form.Control.Feedback>}

                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>

                                                                                </Col>
                                                                            </Row>


                                                                            <Row>
                                                                                <Col className="text-right mt-3">
                                                                                    <this.ContextAwareToggleResults eventKey="1">
                                                                                        <Button disabled={disableSearch} variant="primary" className="mr-2" type="submit" onClick={() => this.handleSubmitFunction(true)}>
                                                                                            Search
                                                                                        </Button>

                                                                                    </this.ContextAwareToggleResults>
                                                                                    {userRole && <Button variant="primary" disabled={disableSearch} className="mr-2" type="submit" onClick={this.handleSavedSearchFunction}>
                                                                                        Save Search
                                                                                    </Button>}
                                                                                    <Button variant="primary" className="mr-2" type="reset" onClick={this.handleResetFunction}>
                                                                                        Reset
                                                                                    </Button>
                                                                                </Col>
                                                                            </Row>

                                                                        </div>

                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card>
                                                        </div>
                                                        <div >
                                                            <Card>
                                                                <Accordion.Toggle as={Card.Header} eventKey="1">
                                                                    Search Results
                                                                    <this.ContextAwareToggle eventKey="1">
                                                                        <FaChevronDown></FaChevronDown>
                                                                    </this.ContextAwareToggle>
                                                                </Accordion.Toggle>
                                                                <Accordion.Collapse eventKey="1">
                                                                    <div>
                                                                        <Card.Body>
                                                                            {<SearchResults masterData={masterData} searchCriteriaObject={searchCriteriaObject} loadResults={loadResults}></SearchResults>}
                                                                        </Card.Body>
                                                                    </div>
                                                                </Accordion.Collapse>
                                                            </Card>
                                                        </div>
                                                    </Accordion>
                                                </Tab>
                                                <Tab eventKey="savedSearch" title="Saved Search" >
                                                    <div className="savedSearchList">
                                                        {!userRole && <Row style={{ marginTop: "35px" }}>
                                                        </Row>}
                                                        <Row>
                                                            <Col className="btns text-right">
                                                                {userRole && <OverlayTrigger
                                                                    placement="bottom"
                                                                    overlay={<Tooltip>Delete Saved Search</Tooltip>}
                                                                >
                                                                    <Button
                                                                        disabled={selected.length < 1}
                                                                        className="addBtn mr-2"
                                                                        onClick={() =>
                                                                            this.deleteSavedSearchModalFunction()
                                                                        }
                                                                        variant="outline-dark"
                                                                    >
                                                                        <FaTrashAlt />
                                                                    </Button>
                                                                </OverlayTrigger>
                                                                }
                                                            </Col>
                                                        </Row>

                                                        <div>
                                                            {sList && <DataTableSelectRow
                                                                keyField="id"
                                                                defaultSortField="date"
                                                                data={this.state.savedSearchDataList}
                                                                columns={savedSearchDataColumns}
                                                                handleOnSelect={this.handleOnSelect}
                                                                handleOnSelectAll={this.handleOnSelectAll}
                                                            />}
                                                        </div>
                                                        <br></br>
                                                        {showResults && <Accordion defaultActiveKey="0">
                                                            <div >
                                                                <Card>
                                                                    <Accordion.Toggle as={Card.Header} eventKey="0">
                                                                        Saved Search Results
                                                                        <this.ContextAwareToggle eventKey="0">
                                                                            <FaChevronDown></FaChevronDown>
                                                                        </this.ContextAwareToggle>
                                                                    </Accordion.Toggle>
                                                                    <Accordion.Collapse eventKey="0">
                                                                        <Card.Body>
                                                                            <SavedSearchResults masterData={masterData} saveTitle={saveTitle} searchCriteriaObject={searchCriteriaObject} loadResults={loadSavedResults}></SavedSearchResults>
                                                                        </Card.Body>
                                                                    </Accordion.Collapse>
                                                                </Card>
                                                            </div>
                                                        </Accordion>}
                                                    </div>

                                                </Tab>
                                            </Tabs>
                                        </div>
                                        {showSaveSearchTitle && <SaveSearchTitle
                                            saveSearchTitle={this.saveSearchTitle}
                                            disableModal={this.disableModal}
                                        />}
                                    </Container>
                                </div >
                                {
                                    isLoading && (
                                        <div className="loader">
                                            <FaSpinner />
                                        </div>
                                    )
                                }
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <div className="page-footer-space"></div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.userDataReducer.loggedUserDetail,
        productData: state.abstractDataReducer.productData,
        usersData: state.userDataReducer.usersData,
        countryData: state.abstractDataReducer.countryData,
        statusData: state.abstractDataReducer.statusData,
        explanationData: state.abstractDataReducer.explanationData
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            loadAllProduct,
            loadAllCountry,
            loadAllExplanation,
            loadAllStatus,
            loadUsersData,
            loadAllSavedSearch,
            saveSearch,
            getSearchCriteria,
            inactiveSaveSearch,

        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));